import { FC } from 'react';
import { SvgIconProps } from '@mui/material';
import { styled } from '@mui/material/styles';

import FileText from '@o2/icons/FileText';
import colors from '@o2/ui/theme/colors';

const StyledFileText = styled(FileText)(() => ({
  color: colors.transparentGray[600],
}));

const GenericIcon: FC<SvgIconProps> = (props) => <StyledFileText {...props} />;

export default GenericIcon;
